import React from 'react';
import { BiomarkerResultStatus } from '../../types/apiGeneratedTypes';

type Props = {
  status: BiomarkerResultStatus;
};

const TestResultStatus = ({ status }: Props) => {
  const getStatusConfig = () => {
    switch (status) {
      case BiomarkerResultStatus.PENDING:
        return {
          backgroundColor: 'rgba(243, 114, 44, 0.2)',
          color: '#F3722C',
          text: 'Pending Approval'
        };
      case BiomarkerResultStatus.AWAITING:
        return {
          backgroundColor: 'rgba(39, 125, 161, 0.2)',
          color: '#277DA1',
          text: 'Awaiting Discussion'
        };
      case BiomarkerResultStatus.URGENT_RESULT:
        return {
          backgroundColor: 'rgba(220, 53, 69, 0.2)',
          color: '#DC3545',
          text: 'Urgent Status'
        };
      default:
        return {
          backgroundColor: 'rgba(144, 190, 109, 0.2)',
          color: '#90BE6D',
          text: 'Published to Member'
        };
    }
  };

  const statusConfig = getStatusConfig();

  return (
    <div 
      className='test-status-container' 
      style={{
        backgroundColor: statusConfig.backgroundColor,
        color: statusConfig.color
      }}
    >
      {statusConfig.text}
    </div>
  );
};

export default TestResultStatus;
